import React from "react";
import { Provider } from "mobx-react";
import SiteSettingStore from "./src/stores/SiteSettingStore";

const ProvideStores = ({ element }) => (
  <Provider siteSettings={new SiteSettingStore()}>{element}</Provider>
);

export default ProvideStores;
